import styled from 'styled-components';
import { media } from '../../themes/breakpoint';
const calculateWidth = (colSpan) => (colSpan / 12) * 100;
// eslint-disable-next-line @typescript-eslint/ban-types
export const Row = styled.div `
  box-sizing: border-box;
  display: flex;
  flex-flow: wrap;
`;
const lg = 12;
const lgLeftOffset = 0;
const lgRightOffset = 0;
const md = 12;
const mdLeftOffset = 0;
const mdRightOffset = 0;
const sd = 12;
const sdLeftOffset = 0;
const sdRightOffset = 0;
export const Column = styled.div `
  box-sizing: border-box;
  padding-top: ${props => props.disableGutter ? 0 : props.theme.dimensions.desktop.verticalGutter}px;
  padding-bottom: ${props => props.disableGutter ? 0 : props.theme.dimensions.desktop.verticalGutter}px;
  padding-left: ${props => props.disableGutter
    ? 0
    : props.theme.dimensions.desktop.horizontalGutter}px;
  padding-right: ${props => props.disableGutter
    ? 0
    : props.theme.dimensions.desktop.horizontalGutter}px;
  flex-basis: ${props => calculateWidth(props.lg || lg)}%;
  max-width: ${props => calculateWidth(props.lg || lg)}%;
  margin-left: ${props => calculateWidth(props.lgLeftOffset || lgLeftOffset)}%;
  margin-right: ${props => calculateWidth(props.lgRightOffset || lgRightOffset)}%;

  ${media.tablet `
    flex-basis: ${props => calculateWidth(props.md || md)}%;
    max-width: ${props => calculateWidth(props.md || md)}%;
    margin-left: ${props => calculateWidth(props.mdLeftOffset || mdLeftOffset)}%;
    margin-right: ${props => calculateWidth(props.mdRightOffset || mdRightOffset)}%;
    padding-top: ${props => props.disableGutter ? 0 : props.theme.dimensions.tablet.verticalGutter}px;
    padding-bottom: ${props => props.disableGutter ? 0 : props.theme.dimensions.tablet.verticalGutter}px;
    padding-left: ${props => props.disableGutter
    ? 0
    : props.theme.dimensions.tablet.horizontalGutter}px;
    padding-right: ${props => props.disableGutter
    ? 0
    : props.theme.dimensions.tablet.horizontalGutter}px;
  `};

  ${media.mobile `
    flex-basis: ${props => calculateWidth(props.sm || props.sd || sd)}%;
    max-width: ${props => calculateWidth(props.sm || props.sd || sd)}%;
    margin-left: ${props => calculateWidth(props.smLeftOffset || props.sdLeftOffset || sdLeftOffset)}%;
    margin-right: ${props => calculateWidth(props.smRightOffset || props.sdRightOffset || sdRightOffset)}%;
    padding-top: ${props => props.disableGutter ? 0 : props.theme.dimensions.mobile.verticalGutter}px;
    padding-bottom: ${props => props.disableGutter ? 0 : props.theme.dimensions.mobile.verticalGutter}px;
    padding-left: ${props => props.disableGutter
    ? 0
    : props.theme.dimensions.mobile.horizontalGutter}px;
    padding-right: ${props => props.disableGutter
    ? 0
    : props.theme.dimensions.mobile.horizontalGutter}px;
  `};
`;
//# sourceMappingURL=index.js.map